import dayjs from 'dayjs'
import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

const PHYSICAL_STRUCTURE_KEYS = ['businessUnit', 'site', 'area']

function toPhysicalStructure(structureFields = []) {
  return PHYSICAL_STRUCTURE_KEYS.reduce((accumulator, key) => {
    accumulator[key] = structureFields.includes(key)
    return accumulator
  }, {})
}

function toIsoDate(date) {
  if (!date)
    return null
  return dayjs(date).format('YYYY-MM-DD')
}

function mapResponse(data) {
  return {
    id: data._id ?? data.id,
    name: data.name,
    status: data.status,
    createdAt: data.createdAt,
  }
}

export async function createSurvey(payload) {
  const body = {
    name: payload.name,
    ...(payload.description ? { description: payload.description } : {}),
    startDate: toIsoDate(payload.startDate),
    endDate: toIsoDate(payload.endDate),
    collectIpAddress: payload.collectIpAddress ?? false,
    enableCaptcha: payload.showCaptcha ?? false,
    respondentIdentification: payload.collectRespondentIdentification ?? false,
    requiresAuthenticatedUsers: payload.requiresAuthenticatedUsers ?? false,
    physicalStructure: toPhysicalStructure(payload.structureFields),
    ...(payload.templateId ? { templateId: payload.templateId } : {}),
  }

  const response = await apiClient('generic-survey').post(SURVEY_ENDPOINTS.CREATE_GENERIC, body)
  return mapResponse(response.data.data)
}
